/*eslint-disable*/
import React, { Component } from 'react'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'

class LeafletMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          lat: 43.252409,
          lng: -79.925817,
          zoom: 18,
          viewport: {
              center: [43.252409,-79.924511],
              zoom: 18,
          }
        }
    };
    onClickedNode = () => {

        this.props.callback();



    }


  render() {
    const position = [this.state.lat, this.state.lng]
    return (
      <Map useFlyTo={false} viewport = {this.state.viewport}>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
      />
        <Marker position={position}>
          <Popup onOpen={this.onClickedNode} onClose={this.onClickedNode}>
            {this.props.name}
          </Popup>
        </Marker>
      </Map>
    )
  }
}

export default LeafletMap
